import { ShopifyCart } from "types";
import { fetchSymbol } from "../fetch/fetch-helper";

const endpoint = '/cart/clear.js';

export async function clear(noIntercept?: boolean): Promise<ShopifyCart> {
  const res = await window[fetchSymbol].postJSON<ShopifyCart>(endpoint, undefined, noIntercept);
  return res;
}
